import { TrackCellType } from '../types/track.js';

/** Catégories visuelles alignées sur les couleurs des cases circuit. */
export type TrackCellBonusVisual = 'straight' | 'turn' | 'start';

/** Couleur texte (cases éditeur / circuit). */
export const TRACK_CELL_BONUS_COLORS: Record<TrackCellBonusVisual, string> = {
  straight: '#14b8a6',
  turn: '#fb923c',
  start: '#facc15',
};

export function resolveTrackCellBonusVisual(
  cellType: TrackCellType | null | undefined,
  mainPathIndex?: number | null,
  onStartLane?: boolean
): TrackCellBonusVisual | null {
  if (onStartLane) return 'start';
  if (mainPathIndex === 0) return 'start';
  switch (cellType) {
    case TrackCellType.STRAIGHT:
    case TrackCellType.JOKER: // obsolète : traité comme droite
      return 'straight';
    case TrackCellType.TURN:
      return 'turn';
    case TrackCellType.START:
    case TrackCellType.START_LANE:
      return 'start';
    default:
      return null;
  }
}

export function trackCellBonusVisualClass(visual: TrackCellBonusVisual | null): string {
  return visual ? `play-race-cell-color--${visual}` : '';
}

export const TRACK_CELL_COLOR_CLASS_NAMES = (
  Object.keys(TRACK_CELL_BONUS_COLORS) as TrackCellBonusVisual[]
).map((key) => `play-race-cell-color--${key}`);
